const ClientsMain = () => import(/* webpackChunkName: "admin-module" */ './index');
const Clients = () => import(/* webpackChunkName: "admin-module" */ './views/Clients');
const Create = () => import(/* webpackChunkName: "admin-module" */ './views/Create');
const Edit = () => import(/* webpackChunkName: "admin-module" */ './views/Edit');
const Show = () => import(/* webpackChunkName: "admin-module" */ './views/Show');

export default [
    {
        path: 'clients',
        components: { base: ClientsMain },
        children: [
            {
                path: '',
                name: 'clients',
                components: { clients: Clients }
            },
            {
                path: 'create',
                name: 'clients.create',
                components: { clients: Create }
            },
            {
                path: ':client_id/edit',
                name: 'clients.edit',
                components: { clients: Edit }
            },
            {
                path: ':client_id/show',
                name: 'clients.show',
                components: { clients: Show }
            }
        ]
    },
];
